import validate from '../../../services/reduxValidate.js'

export default function(data) {
  const constraints = {
    suspended_until: { isoDate: true }
  }

  const errors = {}
  if (!data.subUniverses.filter((subUniverse) => subUniverse.value === true).length) {
    errors.subUniverses = { _error: 'Veuillez sélectionner au moins 1 sous-univers.' }
  }

  return { ...validate(data, constraints), ...errors}
}